// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d6095285","977":"6e17b5c8"}[chunkId] + ".chunk.js";
};